import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";

export class OrganizationSchemaDataModel extends BaseSchemaDataModel {
  knowsAbout: String;
  sameAs: String;
  logo: String;
  description: String;
  legalName: String;
  id: String;
}

export class OrganizationSchemaModel extends BaseSchemaModel {
  model: OrganizationSchemaDataModel;

  constructor(model: OrganizationSchemaDataModel) {
    super(SCHEMA_TYPE.organization, model.name, model.url);

    this.model = model;
  }

  get idParams(): String {
    return this.model.id ? `,"@id":"${this.model.id}"` : ``;
  }

  get legalNameParams(): String {
    return this.model.legalName ? `,"legalName":"${this.model.legalName}"` : ``;
  }

  get descriptionParams(): String {
    return this.model.description ? `,"description":"${this.model.description}"` : ``;
  }

  get logoParams(): String {
    return this.model.logo ? `,"logo": "${this.model.logo}"` : '';
  }

  get knowsAboutParams(): String {
    return `,"knowsAbout": [${this.convertToSchemaString(this.model.knowsAbout)}]`;
  }

  get sameAsParams(): String {
    return `,"sameAs": [${this.convertToSchemaString(this.model.sameAs)}]`;
  }

  get contactPointParams(): String {
    return `,"contactPoint": { "@type": "ContactPoint", "contactType": "customer support", "email": "contact@365scores.com"}`;
  }

  toString(): String {
    return `${super.toString()}${this.idParams}${this.legalNameParams}${this.logoParams}${this.descriptionParams}${this.knowsAboutParams}${this.sameAsParams}${this.contactPointParams}`;
  }

  convertToSchemaString(term: String): String {
    let schemaString = '';
    const termsArray: Array<String> = term?.split(',');

    termsArray?.forEach((item: String, index: Number) => schemaString += this.listItemToString(termsArray, `"${item}"`, index));

    return schemaString;
  }
}

